import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, NgZone, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountdownTimerComponent } from '../countdown-timer/countdown-timer.component';
import { GlobalService } from 'src/app/core/services/global.service';
import { environment as env } from 'src/environments/environment';

@Component({
  selector: 'app-message',
  standalone: true,
  imports: [
    CommonModule,
    CountdownTimerComponent
  ],
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss',`./styles/message.component.${env.template_id}.scss`]
})
export class MessageComponent implements AfterViewInit, OnChanges {

  @Input('href') href: string;
  @Input('text') text: string;
  @Input('type') type: 1 | 2 | 3 | 4; // 1: Estatico, 2: Dinamico, 3: Temporizador
  @Input('extra') extra: any;
  @Input('useSecondaryColor') useSecondaryColor: boolean = false;
  @Input('background_color') background_color: string = '';
  @Input('text_color') text_color: string = '';
  repeatedArray: number[] = [];
  @ViewChild('containerRef') containerRef!: ElementRef;
  @ViewChild('sampleText') sampleRef!: ElementRef;

  velocity: number = 30

  constructor(private _gs: GlobalService, private cdr: ChangeDetectorRef){ }

  ngAfterViewInit(): void {
    if(this._gs.isBrowser){
      this.setRepeatCount();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this._gs.isBrowser){
      this.setRepeatCount();
    }
  }

  setRepeatCount(): void {
    this.cdr.detectChanges();
    const containerWidth = this.containerRef?.nativeElement?.offsetWidth || window.innerWidth;
    let messageWidth = this.sampleRef?.nativeElement?.offsetWidth || 1;
    const count = Math.ceil(containerWidth / messageWidth) + 1;
    this.repeatedArray = Array(count).fill(0);
    this.velocity = count * (messageWidth * (30 / 1000));
  }



}
